// LABEL
export const LABEL_INICIAR_SESION = 'Iniciar sesión';
export const LABEL_SI_AUN_NO_TIENE_UN_USUARIO_PUEDE = 'Si aún no tiene un usuario puede';
export const LABEL_INGRESAR_COMO_INVITADO = 'ingresar como invitado';
export const LABEL_SOLICITAR_UN_USUARIO = 'solicitar un usuario';

// PCHR
export const PCHR_USUARIO = "Usuario";
export const PCHR_CONTRASENA = "Contraseña";

// MENSAJE
export const MSJ_USUARIO_O_CLAVE_INCORRECTA = 'Usuario o clave incorrecta.';
export const MSJ_INGRESE_NOMBRE_USUARIO = 'Ingrese su nombre de usuario';
export const MSJ_INGRESE_CONTRASENA = 'Ingrese su contraseña';
export const MSJ_OLVIDATES_TU_CONTRASENA = '¿Olvidastes tu contraseña?';

// VALUES
export const initialState = { authenticated: false, error: null, loading: false };